import type {PaginationItemProps} from '@ark-ui/react/pagination';
import {Pagination as ArkPagination} from '@ark-ui/react/pagination';
import {ChakraButton} from '@linx-security/ui/utils/chakra-elements';
import {forwardRef} from 'react';

import type {HTMLChakraProps} from '..';

import {useStyles} from './context';

type Props = PaginationItemProps & HTMLChakraProps<'li'>;

export const PaginationItem = forwardRef((props: Props, ref: any) => {
  const {item} = useStyles();
  const {type, value, ...rest} = props;

  return (
    <ArkPagination.Item ref={ref} asChild type={type} value={value}>
      <ChakraButton __css={item} {...rest}>
        {value}
      </ChakraButton>
    </ArkPagination.Item>
  );
});
